import { LoadingButton } from '@mui/lab';
import { Button, IconButton } from '@mui/material';
import styled from 'styled-components';

import { COLORS, light, newLayout } from '../../../../theme';
import Menu from '../../Menu';

export const StyledLoadingButton = styled(LoadingButton)`
  &&& {
    display: flex;
    padding: 8px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    min-height: auto;
    svg {
      width: 16px;
      height: 16px;
      path {
        fill: ${({ $filledColor }) => $filledColor || COLORS.black90};
      }
    }
    border: 1px solid ${COLORS.black20};
    background: ${light.app.primary};
    &.Mui-disabled {
      svg path {
        fill: ${COLORS.black20} !important;
      }
    }
    .MuiLoadingButton-loadingIndicator {
      color: ${({ $filledColor }) => $filledColor || COLORS.black90};
      .MuiCircularProgress-root {
        width: 16px !important;
        height: 16px !important;
      }
    }
  }
`;

export const StyledButton = styled(Button)`
  &&& {
    margin: 0 auto;
    height: ${({ theme }) => theme.spacing.m4};
  }

  .MuiSvgIcon-root {
    font-size: 20px;

    path {
      ${({ $isHeader }) => $isHeader && `fill: ${COLORS.black20};`}
    }
  }
`;

export const StyledLineButton = styled(IconButton)`
  && {
    display: flex;
    svg {
      width: ${({ $size }) => ($size ? newLayout.fontSize.h4 : '16px')};
      height: ${({ $size }) => ($size ? newLayout.fontSize.h4 : '16px')};
      path {
        fill: ${({ $filledColor }) => $filledColor || COLORS.black90};
      }
    }
    padding: 8px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    border: 1px solid ${COLORS.black20};
    background: ${light.app.primary};
    &.Mui-disabled {
      svg path {
        fill: ${COLORS.black20} !important;
      }
    }
  }
`;

export const StyledMenu = styled(Menu)`
  .MuiPaper-root {
    min-width: 168px;
  }
`;

export const StyledFlatItems = styled.div`
  display: flex;
  align-items: center;
  > button {
    margin-right: ${({ theme }) => theme.spacing.s2};
  }
`;
